<template>
  <div
    v-if="shouldShowWarning"
    class="bg-red-600 text-white px-6 py-3 shadow-md"
  >
    <div class="container mx-auto flex items-center justify-between flex-wrap gap-3">
      <div class="flex items-center gap-3">
        <span class="text-xl">⚠️</span>
        <p class="text-sm font-medium">
          Vous utilisez un mot de passe temporaire. Pour des raisons de sécurité, veuillez le modifier.
        </p>
      </div>
      <router-link
        to="/change-password"
        class="bg-white text-red-600 px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
      >
        Changer maintenant
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()

const shouldShowWarning = computed(() => {
  return authStore.user?.flag_password === true
})
</script>
